/* eslint-disable prettier/prettier */
import { createBrowserHistory } from 'history';
export default createBrowserHistory();
